import React from 'react';

type TooltipItem = {
  label: string;
  value: string;
};

type TooltipDetailsProps = {
  items: TooltipItem[];
  containerClassName?: string;
};

export const TooltipDetails: React.FC<TooltipDetailsProps> = ({
  items,
  containerClassName,
}) => {
  return (
    <div className={`tooltip-details-container ${containerClassName}`}>
      {items.map((item, index) => (
        <div className="tooltip-text" key={index}>
          <div className="tooltip-text__label">{item.label}</div>
          <div className="tooltip-text__value">{item.value}</div>
        </div>
      ))}
    </div>
  );
};
